<!--
 * @Auther: 罗耀祖
 * @Date: 2022-08-24 14:17:39
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 14:18:10
 * @name: 工单管理路由
 * @Description: 工单管理路由
 * @FilePath: \preSaleNafterSaleBackstage\src\views\issueManage\issueManageRouter.vue
 * @Author: desktop
-->
<template>
  <keep-alive :include="cashRouters">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: 'issueManageRouter',
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    },
  },
}
</script>